import type { ApiClient, ConfigsT } from '@prismo-io/schemas';

export const fetchExperienceName = async (
  client: ApiClient,
  term: string | null
) => {
  const {
    data: { session },
  } = await client.auth.getSession();

  if (!session) {
    const baseQuery = client
      .from('ref_designations')
      .select('referential_id,code,name')
      .eq('referential_id', 'bd7f2157-8d44-4df9-a4f4-e87eb6f4255e')
      .order('name')
      .limit(50);

    if (!term) {
      const { data } = await baseQuery;

      return data || [];
    }

    // const { data } = await baseQuery.ilike('name', `%${term}%`).limit(50);
    const ftxTerm = term
      .trim()
      .replace(/[-'`~!@#$%^&*()_|+=?;:'",.<>\{\}\[\]\\\/]/gi, '')
      .split(/\s+/g)
      .map((subTerm) => subTerm.trim())
      .filter((subTerm) => subTerm !== '')
      .map((subTerm) => `${subTerm}:*`)
      .join(' & ');

    const { data } = await baseQuery
      .textSearch('search_term', ftxTerm, { config: 'french' })
      .limit(50);

    return data || [];
  }

  const baseQuery = client
    .from('users')
    .select(`
      id,
      config(
        designations(
          code,
          referential_id,
          name
        )
      )
    `)
    .eq('id', session.user.id)
    .limit(50, { foreignTable: 'config.designations' })
    .order('name', { foreignTable: 'config.designations' });

  if (!term) {
    const { data } = await baseQuery.maybeSingle();

    if (!data) {
      return [];
    }

    return (data.config as unknown as ConfigsT).designations || [];
  }

  const ftxTerm = term
    .trim()
    .replace(/[-'`~!@#$%^&*()_|+=?;:'",.<>\{\}\[\]\\\/]/gi, '')
    .split(/\s+/g)
    .map((subTerm) => subTerm.trim())
    .filter((subTerm) => subTerm !== '')
    .map((subTerm) => `${subTerm}:*`)
    .join(' & ');

  const { data } = await baseQuery
    .textSearch('config.designations.search_term', ftxTerm, {
      config: 'french',
    })
    .maybeSingle();

  if (!data) {
    return [];
  }

  return (data.config as unknown as ConfigsT).designations || [];
};
